import tomoLogo from "images/tomo_card_women.webp";
import kosmoLogo from "images/kosmofi/kosmofi_logo.svg";

export default {
  default: {
    title: "TomoCredit – No Credit Score Needed | All-New Black Card",
    description: `Credit Building Starts Here. No Credit History Required. Apply in Minutes! Enjoy Benefits & Coverage Valued at $1,300+. Build / Grow Credit with TomoCredit.`,
    url: "tomocredit.com",
    image: tomoLogo,
  },
  // Insert specific pages below with the name of the page like below

  about: {
    title: "Tomo Credit Card - Learn more about us",
    description: `TomoCredit - No credit score? No problem. The next generation card designed for people with no credit history or credit score.
  Anyone from students to immigrants can all start building credit - without facing high interest rates or relying on secured cards.`,
    url: "tomocredit.com/about",
    image: tomoLogo,
  },

  boost: {
    title: "TomoBoost: Boost Your Credit Score 200+ Fast with AI",
    description: `TomoBoost is a product we developed to help increase credit scores FAST through analyzing successful recurring payments.`,
    url: "tomocredit.com/boost",
    image: tomoLogo,
  },

  faq: {
    title: "Tomo Credit Card - Frequently Asked Questions",
    description: `Have questions about Tomo credit card? View some of our most frequently asked questions.`,
    url: "tomocredit.com/faq",
    image: tomoLogo,
  },

  careers: {
    title: "Tomocredit Jobs – We are hiring!",
    description: `Join the Tomo team and view currently open positions within the company. Apply Now!`,
    url: "tomocredit.com/careers",
    image: tomoLogo,
  },

  support: {
    title: "Tomo Credit Card – Need help? Contact our support team",
    description: `Our team is dedicated to helping you with aynthing you may need regarding your credit card. Contact us with any questions or concerns you may have and we'll be happy to help. `,
    url: "tomocredit.com/support",
    image: tomoLogo,
  },

  ai: {
    title: "TomoCredit – TomoAI | AI-Powered Credit Assistant",
    description: `TomoScore is a modern, cash flow-based credit score that provides a risk-free method for businesses to evaluate the creditworthiness of high-quality borrowers who lack a traditional credit score.`,
  },

  kosmofi: {
    title: "Kosmofi - The Card For Business Owners",
    description: `The Card For Business Owners`,
    url: "kosmofi.com",
    image: kosmoLogo,
  },
};
